<template>
    <div v-show="showPanel && totalResults > 0" ref="autocompletePanel" class="label-autocomplete-panel"
        :style="panelStyle">
        <labelAutocompleteList :filterReportNodes="filterReportNodes" :searchText="searchText" :filterLayerId="filterLayerId" :cursorActive="showPanel"
        @select="selectNode" @onTotalResultsChange="onTotalResultsChange" />
    </div>
</template>

<script>
import labelAutocompleteList from './labelAutocompleteList.vue';

export default {
    name: 'labelAutocompletePanel',
    components: {
        labelAutocompleteList
    },
    props: {
        searchText: {
            type: String,
            default: ''
        },
        filterLayerId: {
            type: String,
            default: null
        },
        filterReportNodes: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            panelStyle: {},
            totalResults: 0,
            inputElementRef: null,
            panelResizeObserver: null,
        }
    },

    computed: {

        showPanel() {
            return this.show;
        }
    },

    watch: {
        showPanel(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.updatePanelPosition();
                    this.observePanelResize();
                });
            }
        },
        inputElementRef: {
            handler(newVal) {
                // Update position when input element reference changes
                if (newVal && this.showPanel) {
                    this.$nextTick(() => {
                        this.updatePanelPosition();
                    });
                }
            },
            immediate: true
        }
    },

    methods: {

        selectNode(node) {
            this.$emit('select', node);
        },

        onTotalResultsChange(totalResults) {
            this.totalResults = totalResults.search;
            this.$emit('onTotalResultsChange', totalResults);
        },

        setInputElementRef(inputElementRef) {
            this.inputElementRef = inputElementRef;
        },

        updatePanelPosition() {
            if (!this.inputElementRef || !this.$refs.autocompletePanel) {
                return;
            }

            const inputRect = this.inputElementRef.getBoundingClientRect();

            let verticalPlacement = 'bottom';
            if (inputRect.bottom + 400 > window.innerHeight) {
                verticalPlacement = 'top';
            }

            const panelHeight = this.$refs.autocompletePanel.clientHeight;

            const maxWidth = Math.max(inputRect.width, 350);
            const minWidth = Math.min(inputRect.width, 300);

            // Position panel below the input using fixed positioning
            if (verticalPlacement == 'bottom') {
                this.panelStyle = {
                    position: 'fixed',
                    top: `${inputRect.bottom + 2}px`,
                    left: `${inputRect.left}px`,
                    minWidth: `${minWidth}px`,
                    maxWidth: `${maxWidth}px`
                };
            } else {
                this.panelStyle = {
                    position: 'fixed',
                    top: `${inputRect.top - panelHeight - 20}px`,
                    left: `${inputRect.left}px`,
                    minWidth: `${minWidth}px`,
                    maxWidth: `${maxWidth}px`
                };
            }
        },

        observePanelResize() {
            if (this.$refs.autocompletePanel && !this.panelResizeObserver) {
                this.panelResizeObserver = new ResizeObserver((entries) => {
                    entries.forEach(entry => {
                        this.updatePanelPosition();
                    });
                });
                this.panelResizeObserver.observe(this.$refs.autocompletePanel);
            }
        },

    },

    beforeDestroy() {
        if (this.panelResizeObserver) {
            this.panelResizeObserver.disconnect();
        }
    },

    mounted() {
        // Update position on mount
        if (this.showPanel) {
            this.$nextTick(() => {
                this.updatePanelPosition();
                this.observePanelResize();
            });
        }

    }
}
</script>

<style scoped>
.label-autocomplete-panel {
    position: absolute;
    z-index: 1000;
    background: white;
    border: 1px solid #D5DDE1;
    border-radius: var(--radius-md);
    padding: var(--spacing-sl);
    /* box-shadow: 0 2px 8px #2B536A22; */
    box-shadow: 0px 4px 12px 0px #00000026;
    overflow: hidden;
    margin-top: var(--spacing-xs);
    animation: fadeIn 0.3s ease-in-out;
}

</style>
